import Icon from "../../components/Icon"
import { formatMoney } from "../../utils/format"
import { getBillStatusMeta } from "./utbillsHelpers"
import { getUtilityInvoiceSettlement } from "./utilitySettlement"

function UtilityInvoiceStatusBadge({ invoice, compact = false, showAmounts = true }) {
  const meta = getBillStatusMeta(invoice)
  const settlement = getUtilityInvoiceSettlement(invoice)
  const settlementDetails = [
    settlement.cashPaidAmount > 0 ? `Paid ${formatMoney(settlement.cashPaidAmount)}` : "",
    settlement.waivedAmount > 0 ? `Waived ${formatMoney(settlement.waivedAmount)}` : "",
  ].filter(Boolean).join(" · ")
  return (
    <span className="inline-flex flex-col items-start gap-0.5">
      {showAmounts && settlementDetails && (
        <span className={compact ? "text-[9px] text-slate-500" : "text-[10px] text-slate-500"}>
          {settlementDetails}
        </span>
      )}
      <span className="inline-flex flex-wrap items-center gap-1">
        <span className={`inline-flex items-center gap-1 rounded-md border font-semibold ${compact ? "px-1 py-0.5 text-[9px]" : "px-1.5 py-0.5 text-[10px]"} ${meta.className}`}>
          <Icon name={meta.icon} size={compact ? "0.55rem" : "0.65rem"} />
          {meta.label}
        </span>
        {meta.isOverdue && (
          <span className={`rounded-md border border-rose-200 bg-rose-50 font-semibold text-rose-700 ${compact ? "px-1 py-0.5 text-[9px]" : "px-1.5 py-0.5 text-[10px]"}`}>
            Overdue
          </span>
        )}
      </span>
    </span>
  )
}

export default UtilityInvoiceStatusBadge
